import { SidebarItem } from '@backstage/core-components';
import {
  appThemeApiRef,
  type AppThemeApi,
  useApi,
} from '@backstage/core-plugin-api';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import Brightness7Icon from '@material-ui/icons/Brightness7';
import { useEffect, useState } from 'react';

type ThemeId = 'light' | 'dark';

const getSystemTheme = (): ThemeId =>
  typeof window !== 'undefined' &&
  window.matchMedia?.('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';

export const getEffectiveTheme = (activeThemeId?: string): ThemeId =>
  activeThemeId === 'light' || activeThemeId === 'dark'
    ? activeThemeId
    : getSystemTheme();

export const getNextTheme = (activeThemeId?: string): ThemeId =>
  getEffectiveTheme(activeThemeId) === 'dark' ? 'light' : 'dark';

export const setNextTheme = (
  appThemeApi: AppThemeApi,
  activeThemeId?: string,
) => {
  const nextTheme = getNextTheme(activeThemeId);
  const isInstalled = appThemeApi
    .getInstalledThemes()
    .some(theme => theme.id === nextTheme);

  if (isInstalled) {
    appThemeApi.setActiveThemeId(nextTheme);
  }
};

export const ThemeToggle = () => {
  const appThemeApi = useApi(appThemeApiRef);
  const [activeThemeId, setActiveThemeId] = useState(
    appThemeApi.getActiveThemeId(),
  );

  useEffect(() => {
    const subscription = appThemeApi
      .activeThemeId$()
      .subscribe(setActiveThemeId);

    return () => subscription.unsubscribe();
  }, [appThemeApi]);

  const nextTheme = getNextTheme(activeThemeId);
  const NextThemeIcon =
    nextTheme === 'light' ? Brightness7Icon : Brightness4Icon;

  const handleToggle = () => setNextTheme(appThemeApi, activeThemeId);

  return (
    <SidebarItem
      icon={NextThemeIcon}
      text={nextTheme === 'light' ? 'Tema claro' : 'Tema escuro'}
      onClick={handleToggle}
    />
  );
};
